/**
 * The phone's words for the notification permission (piece 35, *Push notifications (Stage 0)*; decision 4643),
 * shown once before the system's own prompt so the reason is the app's, and spread into the one string lookup.
 */
export const PUSH_STRINGS = {
  'mobile.push.permissionTitle': 'Allow Notifications',
  'mobile.push.permissionReason': 'BMS2 sends a notification when new mail arrives or an Expense Report is submitted, approved or rejected. The notification names the record by number and never carries its title, an amount or a subject.',
  'mobile.push.permissionAllow': 'Continue',
  'mobile.push.permissionLater': 'Not Now',
} as const;
